const thorConfig = {
    "enableAngularOptims": true,
    "contentApi": {
        "url": "//thor-api.interencheres-sandbox.com",
    },
    "searchApi": {
        "url": "//search-private.interencheres-sandbox.com",
        "maxLimit": 10000
    },
    "uploadApi": {
        "url": "//upload.interencheres-sandbox.com"
    },
    "authApi": {
        "url": "//auth.interencheres-sandbox.com"
    },
    "statApi": {
        "url": "//stat.interencheres-sandbox.com"
    },
    "userApi": {
        "url": "//user.interencheres-sandbox.com"
    },
    "gatewayApi": {
        "url": "//gateway.interencheres-sandbox.com",
        "statusTimeout": 10000
    },
    "liveLegacyApi": {
        "url": "//live-legacy.interencheres-sandbox.com"
    },
    "paymentApi": {
        "url": "//payment.interencheres-sandbox.com"
    },
    "onlineApi": {
        "url": "//online.interencheres-sandbox.com"
    },
    "lemag": {
        "apiUrl": "//magazine.interencheres-sandbox.com/wp-json/wp/v2",
        "authUrl": "//magazine.interencheres-sandbox.com/wp-json/jwt-auth/v1"
    },
    "ie": {
        "domain": "atlas.interencheres-sandbox.com",
        "url": "https://www.interencheres-sandbox.com",
        "extension": {
            "id": "kpmeahoohnlpnafmonnaniiccckjpkgk",
            "majorVersion": "4"
        },
        "support": {
            "phoneNumber": "None",
            "phoneNumberInter": "None"
        }
    },
    "auction": {
        "domain": "None",
        "url": "https://None",
        "extension": {
            "id": "None",
            "majorVersion": "4"
        },
        "support": {
            "phoneNumber": "None"
        }
    },
    "thorAuthUrl": "//atlas.interencheres-sandbox.com/login",
    "supportIEUrl": "None",
    "primus": {
        "endpoint": "//broker.interencheres-sandbox.com",
        "options": {
            "manual": true
        }
    },
    "logs": {
        "pushToServer": ["log", "info", "warn", "error", "debug"]
    },
    "gmaps": {
        "key": "AIzaSyCe2UEl6BE-7-eSjj7dwfZW1H8Oge96Z68",
        "version": "3.49"
    },
    "items": {
        "maxImages": 50
    },
    "onlineCommissionRate": 3.6,
    "defaultSecretTime": 72,
    "recaptchaPublicKey": "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    "resizeDomainPrefix": "",
    "thumborSecret": "ZR0qHUoKRJKkEz4F6CRjqUkRvWmqYe72",
    "pagination": {
        "default": 200,
        "low": 30
    },
    "googleAnalytics": {
        "enabled": false,
        "id": "None"
    },
    "googleTagManager": {
        "ie": {
            "id": "None"
        },
        "auction": {
            "id": "None"
        }
    },
    "stripeSaleCreationDeadline": "2025-07-01T00:00:00Z",
    "enableV2": {
        "header": {
            "futureSaleLiveClassic": "true",
            "pastSaleLiveClassic": "true",
            "futureSaleOnline": "true",
            "pastSaleOnline": "false"
        }
    }
};

module.exports = thorConfig;
